var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { HeaderRoot } from './Header.styled';
import { CoherenceHeader } from '@cseo/controls/lib/header/CoherenceHeader';
import { useUser } from '@employee-experience/common/lib/useUser';
import { useGraphPhoto } from '@employee-experience/common/lib/useGraphPhoto';
import { HeaderPanel } from './Header.types';
import { ComponentContext } from '@employee-experience/common/lib/ComponentContext';
import { EventType, UsageEventName } from '@employee-experience/common/lib/Models/UsageTelemetry';
export function Header(props) {
    var _a, _b, _c, _d;
    const { farRightSettings, searchSettings } = props, otherProps = __rest(props, ["farRightSettings", "searchSettings"]);
    const { telemetryClient, authClient } = React.useContext(ComponentContext);
    const user = useUser();
    const photo = useGraphPhoto();
    const searchConfig = searchSettings;
    if (searchConfig) {
        const originalOnSearch = searchConfig.onSearch;
        searchConfig.onSearch = (searchTerm) => {
            if (!originalOnSearch)
                return;
            const searchEvent = {
                subFeature: 'Header.Search',
                businessTransactionId: searchTerm,
                type: EventType.User,
                eventName: UsageEventName.TextChanged,
            };
            telemetryClient.trackEvent(searchEvent);
            originalOnSearch(searchTerm);
        };
    }
    const handleLogOutClicked = () => {
        const logout = {
            subFeature: 'Header.Logout',
            type: EventType.User,
            eventName: UsageEventName.ButtonClicked,
        };
        telemetryClient.trackEvent(logout);
        authClient.logOut().catch();
    };
    const getPanelOpenHandler = (panel) => {
        return () => {
            const panelEvent = {
                subFeature: `Header.${panel.toString()}`,
                type: EventType.User,
                eventName: UsageEventName.PanelOpened,
                businessTransactionId: panel.toString(),
            };
            telemetryClient.trackEvent(panelEvent);
            telemetryClient.startTrackPage(panel);
        };
    };
    const getPanelDismissHandler = (panel) => {
        return () => {
            const panelEvent = {
                subFeature: `Header.${panel.toString()}`,
                type: EventType.User,
                eventName: UsageEventName.PanelClosed,
                businessTransactionId: panel.toString(),
            };
            telemetryClient.trackEvent(panelEvent);
            telemetryClient.stopTrackPage(panel);
        };
    };
    const notificationConfig = farRightSettings === null || farRightSettings === void 0 ? void 0 : farRightSettings.notificationsSettings;
    if (notificationConfig) {
        notificationConfig.panelSettings.onOpened = getPanelOpenHandler(HeaderPanel.NotificationPanel);
        notificationConfig.panelSettings.onDismissed = getPanelDismissHandler(HeaderPanel.NotificationPanel);
    }
    const settingsConfig = farRightSettings === null || farRightSettings === void 0 ? void 0 : farRightSettings.settingsSettings;
    if (settingsConfig) {
        settingsConfig.panelSettings.onOpened = getPanelOpenHandler(HeaderPanel.SettingsPanel);
        settingsConfig.panelSettings.onDismissed = getPanelDismissHandler(HeaderPanel.SettingsPanel);
    }
    const helpConfig = farRightSettings === null || farRightSettings === void 0 ? void 0 : farRightSettings.helpSettings;
    if (helpConfig) {
        helpConfig.panelSettings.onOpened = getPanelOpenHandler(HeaderPanel.HelpPanel);
        helpConfig.panelSettings.onDismissed = getPanelDismissHandler(HeaderPanel.HelpPanel);
    }
    const feedbackConfig = farRightSettings === null || farRightSettings === void 0 ? void 0 : farRightSettings.feedbackSettings;
    if (feedbackConfig) {
        const prevOnClick = (_a = farRightSettings === null || farRightSettings === void 0 ? void 0 : farRightSettings.feedbackSettings) === null || _a === void 0 ? void 0 : _a.panelSettings.onClick;
        feedbackConfig.panelSettings.onClick = () => {
            if (!prevOnClick)
                return false;
            getPanelOpenHandler(HeaderPanel.FeedbackPanel);
            return prevOnClick();
        };
    }
    const profileConfig = Object.assign(Object.assign({}, farRightSettings === null || farRightSettings === void 0 ? void 0 : farRightSettings.profileSettings), { panelSettings: Object.assign(Object.assign({}, (_b = farRightSettings === null || farRightSettings === void 0 ? void 0 : farRightSettings.profileSettings) === null || _b === void 0 ? void 0 : _b.panelSettings), { logOutLink: 'javascript:void(0);', fullName: (_c = user === null || user === void 0 ? void 0 : user.name) !== null && _c !== void 0 ? _c : '', emailAddress: (_d = user === null || user === void 0 ? void 0 : user.email) !== null && _d !== void 0 ? _d : '', imageUrl: photo || undefined, onLogOut: handleLogOutClicked, onOpened: getPanelOpenHandler(HeaderPanel.ProfilePanel), onDismissed: getPanelDismissHandler(HeaderPanel.ProfilePanel) }) });
    return (React.createElement(HeaderRoot, null,
        React.createElement(CoherenceHeader, Object.assign({}, otherProps, { searchSettings: searchConfig, farRightSettings: Object.assign(Object.assign({}, farRightSettings), { notificationsSettings: notificationConfig, settingsSettings: settingsConfig, helpSettings: helpConfig, feedbackSettings: feedbackConfig, profileSettings: profileConfig }), telemetryHook: telemetryClient }))));
}
//# sourceMappingURL=Header.js.map